import React, { FC } from 'react';
import styled from 'styled-components';
import StatusIndicatorStep, {
    LC_STATUS_LABEL_LIVE_IN_COLLECTION,
    LC_STATUS_LABEL_NEW_UPDATED,
    LC_STATUS_LABEL_PROCESSING
} from './StatusIndicatorStep';
import LibxStep from './LibxStep';
import InactiveStep from './InactiveStep';

const StatusStepContainer = styled.ol<{ disabled: boolean }>`
    margin-left: -2em;
    opacity: ${props => (props.disabled ? '0.5' : 'initial')};
`;
interface Props {
    newUpdated: boolean;
    processing: boolean;
    liveCollection: boolean;
    liveLibx: boolean;
    inactive: boolean;
    disabled?: boolean;
}
const LCStatusIndicator: FC<Props> = props => {
    function calcNumberOfSteps(isInactive) {
        const libXSteps = 1;
        const inactiveSteps = 1;
        const independentSteps = 3;

        if (isInactive) {
            return independentSteps + libXSteps + inactiveSteps;
        } else {
            return independentSteps + libXSteps;
        }
    }

    const { newUpdated, processing, liveCollection, liveLibx, inactive, disabled = false } = props;
    const numberOfSteps = calcNumberOfSteps(inactive);

    const highlightNewUpdated = newUpdated && !processing;
    const highlightProcessing = processing;
    const highlightLiveCollection = liveCollection && !newUpdated && !processing;
    const highlightLiveLibx = liveLibx && !newUpdated && !processing;

    const forceGreenLine = newUpdated && processing;

    return (
        <StatusStepContainer disabled={disabled} data-displayname="StatusStepContainer">
            <StatusIndicatorStep
                enabled={newUpdated}
                highlighted={highlightNewUpdated}
                numberOfSteps={numberOfSteps}
                text={LC_STATUS_LABEL_NEW_UPDATED}
            />
            <StatusIndicatorStep
                forceGreenLine={forceGreenLine}
                numberOfSteps={numberOfSteps}
                enabled={processing}
                text={LC_STATUS_LABEL_PROCESSING}
                highlighted={highlightProcessing}
            />
            <StatusIndicatorStep
                numberOfSteps={numberOfSteps}
                enabled={liveCollection}
                highlighted={highlightLiveCollection}
                text={LC_STATUS_LABEL_LIVE_IN_COLLECTION}
            />
            <LibxStep live={liveLibx} numberOfSteps={numberOfSteps} highlighted={highlightLiveLibx} />
            {inactive ? <InactiveStep numberOfSteps={numberOfSteps} /> : null}
        </StatusStepContainer>
    );
};

export default LCStatusIndicator;
